import styled from 'styled-components'

export const Container = styled.div`
  display: grid;
  grid-template-columns: 1fr 49rem;
  border-radius: 20px;
  padding: 1rem;
  background: linear-gradient(90deg, rgb(2, 12, 49) 0%, rgb(58, 100, 248) 100%);

  @media (max-width: 999px) {
    grid-template-columns: 1fr 34.4rem;
  }

  @media (max-width: 767px) {
    grid-template-columns: repeat(1, 1fr);
    gap: 2.5rem;
  }
`

export const InfoBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  padding: 3rem;

  @media (max-width: 767px) {
    padding: 1rem;
  }
`

export const Title = styled.h2`
  color: white;
  font-family: coolvetica, Arial, Helvetica, sans-serif;
  font-size: 4.2rem;
  font-weight: 400;
  line-height: 4.8rem;
  text-wrap: balance;
`

export const Subtitle = styled.p`
  color: white;
  font-family: 'Navigo', Arial, Helvetica, sans-serif;
  font-size: 1.6rem;
  font-weight: 400;
  line-height: 2.4rem;
`

export const Form = styled.div`
  display: flex;
  flex-direction: column;
  gap: 3rem;
  padding: 3rem;
  border-radius: 10px;
  background: #ebeffe;
`

export const Block = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1.5rem;

  > *:nth-child(3),
  > *:nth-child(4),
  > *:nth-child(5) {
    grid-column: span 2;
  }
`

export const LabelWrap = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`

export const Select = styled.div`
  width: 100%;
`

export const Footer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  gap: 1.5rem;
`

export const Button = styled.button`
  width: 100%;
  height: 5rem;
  padding: 0 2rem 0 2rem;
  border-radius: 20px;
  font-family: 'Navigo', Arial, Helvetica, sans-serif;
  font-size: 1.4rem;
  line-height: 2rem;
  color: white;
  font-weight: 400;
  border-radius: 5px;
  background: #3a64f8;
`

export const Text = styled.p`
  font-family: 'Navigo', Arial, Helvetica, sans-serif;
  font-size: 1.4rem;
  line-height: 2rem;
  color: #292e3d;
  font-weight: 400;
  margin: 1rem 0 0;
`
